import React, { useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { IResponsePost } from "../../Interfaces/base/IResponse";
import EquipoService from "../../services/ListaVerificacion/EquipoService";
import { IPostCrearEquipo } from "../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";

export const useEquipos = (refreshTable?: () => void) => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
    useBoolean(false);

  const postCrearEquipo = (request: IPostCrearEquipo) => {
    ocultarMensaje();
    onEnviar();
    EquipoService.PostCrearEquipo(request)
      .then((res) => {
        if (res.status === 200) {
          setResponse({
            codigoMensaje: res.data.codigoMensaje,
            mensaje: res.data.mensaje,
          });
          onCancelar();
          if (refreshTable) {
            refreshTable();
          }
        }
      })
      .catch((e: Error) => {
        onCancelar();
      });
  };
  const ocultarMensaje = () => {
    setResponse(null!);
  };
  return {
    postCrearEquipo,
    ocultarMensaje,
    response,
    isSend,
  };
};
